import Radio from 'antd-mobile/lib/radio';
export default Radio;



// WEBPACK FOOTER //
// ./components/radio/index.tsx